import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';
import { PageLayout } from '@/components/ui/PageLayout';

export function AdminSettings() {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('admin.settings.title')} subtitle={t('admin.settings.subtitle')}>

      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-ds-field bg-ds-sunk py-16">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-ds-neutral-tint">
          <Construction className="h-8 w-8 text-ds-muted" />
        </div>
        <h3 className="mt-4 text-lg font-medium text-ds-text">{t('admin.settings.coming_soon')}</h3>
        <p className="mt-2 max-w-sm text-center text-sm text-ds-muted">
          {t('admin.settings.coming_soon_desc')}
        </p>
      </div>
    </PageLayout>
  );
}
